module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 27.bb494e6a.png";